import React from 'react';
import { Col, Drawer } from 'antd';
import useToggleFilter from '../../hooks/useToggleFilter';
import { useDispatch, useSelector } from 'react-redux';
import { filterVisibleSelector } from '../../store/selectors';
import { rows } from './constants';
import { resetFilterState } from '../../store/actions';
import FilterRow from './components/FilterRow/FilterRow';

const Filter = () => {
  const visible = useSelector(filterVisibleSelector);
  const userInfo = useSelector((state) => state.authentication.userInfo);
  const showCompanies = userInfo.ServiceCompanyFilter;

  const dispatch = useDispatch();

  const toggleFilter = useToggleFilter();

  const handleReset = () => dispatch(resetFilterState());

  return (
    <Drawer
      title="Фильтр"
      visible={visible}
      onClose={() => toggleFilter(false)}
      width={520}
      drawerStyle={{ backgroundColor: '#f9f9f9' }}
      bodyStyle={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
    >
      {rows.map((row, index) => {
        return (
          <FilterRow key={index} gutter={row.gutter}>
            {row.children.map((child, index) => (
              <Col key={index} span={child.span} offset={child.offset}>
                {child.render({
                  onReset: handleReset,
                  showCompanies,
                })}
              </Col>
            ))}
          </FilterRow>
        );
      })}
    </Drawer>
  );
};

export default Filter;
